import { FC, useEffect, useState } from "react";
import { convertLowerCase, showToast } from "../../../../../helpers/utils/Utils";
import EditorPropertyPickerModal from "../Modals/EditorPropertyPickerModal";
import ConfirmationModal from "../../../../../components/layout/modal/ConfirmationModal";
import { NoteAddSection } from "../Modals/NoteAddSection";
import {
    useCancelOrderOnVendorMutation,
    useDeleteNoteServiceMutation,
    useLazyGetQCLogicResultListQuery
} from "../../../productsApi";
import { CloneAccountsModal } from "../Modals/CloneAccountsModal";
import { useGetAllCountyByStateAbbrQuery } from "../../../../data/counties/countiesApi";
import { tgxApi } from "../../../../../app/tgxApi";
import { useDispatch } from "react-redux";
import {
    useAcknowledgeQcLogicMutation,
    useCheckHoaOrderResultValidMutation,
    useLazyCheckTaxOrderResultValidQuery
} from "../../../ordersApi";
import InputField from "../../../../../components/common/form/InputField";


interface Props {
    address?: any;
    assignTo?: any;
    cadInfoData?: any;
    certificate: any;
    certNoteList: any;
    countyData?: any;
    customerNoteList: any;
    editable?: any;
    haveOrderResult?: any;
    legalDescription?: any;
    linkedListLoader?: any;
    similarTaxAccountListResponse?: any;
    noteType: any;
    orderData?: any;
    orderId?: any;
    orderResultData?: any;
    ownerName?: any;
    productId?: any;
    productType?: any;
    propertyResultTaxList?: any;
    qcLogicResultData?: any;
    qcResultList?: any;
    removedAccountIds?: any;
    setAddAccountSelectedProperty?: any;
    addAccountSelectedProperty?: any
    setAddedNewAccount?: any;
    setAddress?: any;
    setCertificate: any;
    setIsFetchLinkedAccountList?: any;
    setIsFetchSimilarAccountList?: any;
    setIsSavedResult?: any;
    setIsValidDataForPdfGenerate?: any;
    setLegalDescription?: any;
    setOwnerName?: any;
    setPropertyResultTaxList?: any;
    setSelectedCloneAccountList?: any;
    setShowAccount: any;
    setShowDeleteAccountConfirmation?: any;
    setTaxAccountNumber?: any;
    setTaxCheckedList?: any;
    setUpdatedAccountIndexList?: any;
    showAccount: any;
    showAccountCloneModal?: any;
    showDeleteAccountConfirmation?: any;
    similarAccountList: any;
    taxAccountNumber?: any;
    taxCheckedList?: any;
    updatedAccountIndexList?: any;
    unAcknowledged?: any;
    vendorTaskList?: any;
    setShowAccountCloneModal?: any;
    productSchema?: any
    setCertNotes?: any;
    isFetchSimilarAccountList?: any
    getPropertyPickerResultApi?: any,
    getPropertyPickerResult?: any
}

const LeftBar: FC<Props> = ({
    address = null,
    assignTo = null,
    certificate,
    certNoteList,
    customerNoteList,
    setCertNotes,
    editable,
    legalDescription = null,
    linkedListLoader,
    similarTaxAccountListResponse,
    noteType,
    orderData,
    orderId,
    orderResultData,
    ownerName = null,
    productId,
    productType = "TAX_CERTIFICATE",
    propertyResultTaxList = null,
    qcResultList,
    removedAccountIds,
    setAddAccountSelectedProperty,
    setAddedNewAccount,
    setAddress = null,
    setCertificate,
    setIsFetchLinkedAccountList,
    setIsFetchSimilarAccountList,
    setIsSavedResult,
    setIsValidDataForPdfGenerate,
    setLegalDescription = null,
    setOwnerName = null,
    setPropertyResultTaxList = null,
    setSelectedCloneAccountList,
    setShowAccount,
    setShowDeleteAccountConfirmation,
    setTaxAccountNumber = null,
    setTaxCheckedList = null,
    setUpdatedAccountIndexList,
    showAccount,
    showAccountCloneModal,
    showDeleteAccountConfirmation,
    similarAccountList,
    taxAccountNumber = null,
    taxCheckedList = null,
    updatedAccountIndexList,
    unAcknowledged,
    vendorTaskList,
    setShowAccountCloneModal,
    getPropertyPickerResultApi,
    getPropertyPickerResult
}) => {

    const [type, setType] = useState("");
    const [showAddNoteForm, setShowAddNoteForm] = useState(false);
    const [certNoteId, setCertNoteId] = useState("");
    const [showDeleteNoteConfirmation, setShowDeleteNoteConfirmation] = useState(false);
    const [showAllQcResult, setShowAllQcResult] = useState(false);
    const [qcId, setQcId] = useState("");
    const [showPropertyPickerModal, setShowPropertyPickerModal] = useState(false);
    const [isAddAccountPropertyRef, setIsAddAccountPropertyRef] = useState(false);
    const [disable, setDisable] = useState(false);
    const [cancelOrderModel, setCancelOrderModel] = useState(false);
    const [taskHandleType, setTaskHandleType] = useState<string | null>(null);
    const [taskId, setTaskId] = useState(null);
    const [reloadSimilarAccount, setReloadSimilarAccount] = useState(false);
    const [showVendorPropertyResolver, setShowVendorPropertyResolver] = useState(false);
    const [propertyId, setPropertyId] = useState(null);
    const [propertyResultData, setPropertyResultData] = useState(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [isSearch, setIsSearch] = useState(false);
    const [deleteCertNotes, deleteApi] = useDeleteNoteServiceMutation();
    const [cancelOrderOnVendor, cancelOrderOnVendorResponse] = useCancelOrderOnVendorMutation();
    const [customerOrderNumber, setCustomerOrderNumber] = useState(null);
    const countyResp = useGetAllCountyByStateAbbrQuery(orderData?.data?.state)
    const dispatch = useDispatch();
    const [triggerCheckTaxValidation] = useLazyCheckTaxOrderResultValidQuery();
    const [checkHoaValidation] = useCheckHoaOrderResultValidMutation();
    const [acknowledgeQcLogic] = useAcknowledgeQcLogicMutation();
    const [triggerGetQcLogic] = useLazyGetQCLogicResultListQuery();


    useEffect(() => {
        if (reloadSimilarAccount) {
            setIsFetchSimilarAccountList(true);
            setReloadSimilarAccount(false);
        }
    }, [reloadSimilarAccount]);

    const deleteCertNote = (): void => {
        if (certNoteId !== '') {
            setDisable(true);
            deleteCertNotes({
                orderId: orderData?.data?.id,
                noteId: certNoteId
            }).then(() => {
                setShowDeleteNoteConfirmation(false)
                const updatedList = certNoteList.filter((note: any) => note.id !== certNoteId);
                dispatch(tgxApi.util.invalidateTags([
                    "orderNoteList"
                ]));
                setCertNotes(updatedList);
                setDisable(false);
            });
        }
    };


    const cancelOrder = async (): Promise<void> => {
        if (!taskId) return;

        setDisable(true);

        try {
            const response = await cancelOrderOnVendor(taskId).unwrap();

            if (response.errorCode === 200) {
                showToast(
                    taskHandleType === 'REFRESH'
                        ? "Order Refreshed successfully"
                        : "Cancel order on vendor successfully",
                    "success"
                );

                setCancelOrderModel(false);
                setTaskHandleType(null);

                if (noteType === "TAX") {
                    const validationResponse = await triggerCheckTaxValidation(orderResultData.data).unwrap();
                    setIsValidDataForPdfGenerate(validationResponse || false);
                } else {
                    const hoaResponse = await checkHoaValidation({
                        orderId,
                        obj: orderResultData.data,
                    }).unwrap();
                    setIsValidDataForPdfGenerate(hoaResponse?.data?.isValid || false);
                }

                dispatch(tgxApi.util.invalidateTags(["productTaskList", "orderById"]));
            } else {
                setCancelOrderModel(false);
                dispatch(tgxApi.util.invalidateTags(["productTaskList"]));
            }
        } catch (error: any) {
            showToast(error?.message || "Something went wrong", "error");
        } finally {
            setDisable(false);
        }
    };


    const deleteAccount = (): void => {
        const accountId = certificate.accounts[showAccount]?.id;
        if (accountId) {
            removedAccountIds?.push(accountId);
        }

        if (propertyResultTaxList !== null) {
            setPropertyResultTaxList(
                propertyResultTaxList.filter((_: any, index: any) => index !== showAccount)
            );
            setTaxCheckedList(
                taxCheckedList.filter((_: any, index: any) => index !== showAccount)
            );
        }

        if (updatedAccountIndexList?.length > 0) {
            const temp: number[] = updatedAccountIndexList?.map((el: any) =>
                el > 0 ? el - 1 : 0
            );
            setUpdatedAccountIndexList(temp);
        }

        setCertificate((prev: any) => ({
            ...prev,
            accounts: prev.accounts.filter((_: any, index: any) => index !== showAccount),
            propertyIds: prev.propertyIds.filter((_: any, index: any) => index !== showAccount),
        }));

        setShowDeleteAccountConfirmation(false);
        setShowAccount(0);
        if (noteType === "TAX") {
            setIsFetchSimilarAccountList(true);
        }
        setIsSavedResult(false);
    };

    useEffect(() => {
        if (certificate.accounts.length === 0) {
            setAddAccountSelectedProperty(null);
            setAddedNewAccount(true);
        }
    }, [certificate.accounts]);

    ////search /////
    useEffect(() => {
        if (isSearch) {
            let updatedPropertyIds;
            if (searchValue !== '') {
                updatedPropertyIds = certificate.propertyIds.map((el: any) =>
                    convertLowerCase(el.id).includes(searchValue) ? { ...el, visibility: true } : {
                        ...el,
                        visibility: false
                    }
                );

            } else {
                updatedPropertyIds = certificate.propertyIds.map((el: any) =>
                    convertLowerCase(el.id).includes(searchValue) ? { ...el, visibility: true } : {
                        ...el,
                        visibility: true
                    }
                );
            }
            // Don't mutate original object directly
            setCertificate({
                ...certificate,
                propertyIds: updatedPropertyIds,
            });

            setIsSearch(false);
        }
    }, [isSearch, certificate, searchValue]);


    useEffect(() => {
        const handleAcknowledge = async () => {
            if (qcId !== "") {
                try {
                    const result = await acknowledgeQcLogic(qcId).unwrap();

                    if (result?.errorCode === 200) {
                        showToast(result.message, "success");

                        // Trigger the query manually
                        await triggerGetQcLogic(productId).unwrap();
                    }
                } catch (error: any) {
                    showToast(error?.message || "Error acknowledging QC logic", "error");
                } finally {
                    setQcId("");
                    setIsRefetching(false);
                }
            }
        };

        handleAcknowledge();
    }, [qcId]);



    return (
        <>

            {certificate &&
                <div className="bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]">
                    <div
                        className={noteType === "TAX" ? "px-2 py-2 bg-highlight-5  m-0 text-text-1 flex items-center" : "m-0  bg-highlight-1 px-1 py-2 text-text-1 flex items-center"}>
                        <p className="mb-0">Accounts {`(${certificate?.accounts?.length || 0})`}</p>
                        {noteType === "TAX" && (
                            <i
                                className={`ml-auto cursor-pointer fa ${linkedListLoader ? "fas fa-sync fa-spin ml-auto h-4" : "fa-refresh"
                                    }`}
                                title="Linked Account"
                                aria-hidden="true"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (editable) {
                                        setIsFetchLinkedAccountList(true);
                                    }
                                }}
                            />
                        )}

                        {noteType === "TAX" &&
                            <i className="cursor fa-house-signal fa-solid ml-3" title="Property Picker"
                                aria-hidden="true" onClick={() => {
                                    if (editable) {
                                        setShowPropertyPickerModal(true);
                                        setIsAddAccountPropertyRef(false);
                                    }
                                }} />
                        }

                        <i className={noteType === "TAX" ? "cursor fa fa-clone fa-solid ml-3" : "cursor fa fa-clone fa-solid ml-auto"}
                            title="Clone Accounts"
                            aria-hidden="true" onClick={() => {
                                if (editable) {
                                    setShowAccountCloneModal(true);
                                }
                            }} />


                        <i className={"fa fa-plus-circle ml-3 cursor"}
                            title={'Add Account'}
                            aria-hidden="true" onClick={() => {
                                if (editable) {
                                    setIsAddAccountPropertyRef(true);
                                    setShowPropertyPickerModal(true);
                                }
                            }
                            } />

                    </div>
                    {certificate?.propertyIds?.length > 10 &&
                        <div className="p-2 bg-surface-7">
                            <label className="relative">
                                <InputField className="rounded-[35px] border border-text-1 pl-6" type="search"
                                    placeholder="Filter accounts..."
                                    onChange={(e) => {
                                        setSearchValue(e.target.value)
                                        setIsSearch(true);
                                    }}
                                    hideLabel
                                />
                                <i className="fa fa-filter absolute left-[8px] top-[22px]" />
                            </label>

                        </div>}

                    <div className="tax_list">
                        <ul>
                            {certificate?.propertyIds?.length > 0 && certificate?.propertyIds?.map((curAccount: any, p: any) => {
                                return (
                                    <>

                                        <li className={curAccount?.visibility === true ? (p === showAccount ? (noteType === "TAX" ? "p-2 border border-highlight-3 bg-highlight-3 text-text-0 flex d-flex align-items-center cursor" : "p-2 bg-highlight-2 text-text-0 d-flex align-items-center cursor") : 'p-2 flex align-items-center cursor') : "hidden"}
                                            onClick={() => {
                                                setShowAccount(p);
                                            }}>

                                            {noteType === "TAX" &&
                                                <span
                                                    className="break-all">{curAccount.id === '' ? 'N/A' : curAccount.id}</span>
                                            }

                                            {noteType === "HOA" &&
                                                <div>
                                                    <p className="m-0">{curAccount.id === null || curAccount.id === '' ? 'N/A' : curAccount.id}</p>
                                                    <p className={"break-all m-0"}
                                                        title={certificate?.accounts[p]?.associationName}>{certificate?.accounts[p]?.associationName != null && certificate.accounts[p].associationName !== '' ? (certificate.accounts[p].associationName.length > 20 ? certificate.accounts[p].associationName.substring(0, 20) + " ..." : certificate.accounts[p].associationName) : ""}</p>
                                                </div>
                                            }

                                            {noteType === "TAX" &&
                                                <i className={certificate?.accounts[p]?.linkedAccountId !== undefined && certificate?.accounts[p]?.linkedAccountId !== null && certificate?.accounts[p]?.linkedAccountId !== "" ? "cursor fa fa-link ml-auto" : "ml-auto"}
                                                    aria-hidden="true"
                                                    title={certificate?.accounts[p]?.linkedAccountDTO?.accountNumber}></i>
                                            }

                                            <i className={editable === true ? (noteType === "TAX" ? "fa fa-trash ml-4 cursor" : "fa fa-trash ml-auto cursor") : (noteType === "TAX" ? "fa fa-trash ml-4" : "fa fa-trash ml-auto")}
                                                aria-hidden="true"
                                                title={'Delete Account'}
                                                onClick={() => {
                                                    if (editable) {
                                                        setShowAccount(p);
                                                        setShowDeleteAccountConfirmation(true);
                                                    }
                                                }} />
                                        </li>
                                    </>
                                )
                            }
                            )}
                            {(certificate.propertyIds?.length === 0 || certificate?.propertyIds?.find((element: any) => {
                                return (element?.visibility === true);
                            }) === undefined) &&
                                <li className="d-flex align-items-center p-2">No accounts found</li>
                            }
                        </ul>
                    </div>

                </div>
            }


            <div className="bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]">
                <div
                    className={noteType === "TAX" ? "p-1 bg-highlight-5 d-flex align-items-center m-0 text-text-1" : "m-0 bg-highlight-1 px-1 py-2 text-text-1 d-flex align-items-center"}>
                    <p className="mb-0">Customer Notes {`(${customerNoteList?.length || 0})`}</p>
                </div>

                <div className="break-all">
                    <ul>
                        {customerNoteList && customerNoteList.length === 0 &&
                            <li className="d-flex align-items-center p-2">No Notes found</li>
                        }
                        {customerNoteList && customerNoteList.length > 0 && customerNoteList.map((curAccount: any) => {
                            return (
                                <li className="d-flex align-items-center border border-[#d0d2d5] bg-surface-5 p-1">
                                    <p>{curAccount.noteBody}</p></li>
                            )
                        })
                        }
                    </ul>
                </div>
            </div>

            <div className="bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]">
                <div
                    className={noteType === "TAX" ? "p-1 bg-highlight-5  m-0 text-text-1 flex items-center" : "m-0 text-text-1  bg-highlight-1 px-1 py-2 flex items-center"}>
                    <p className="mb-0">{noteType === "TAX" ? "Tax" : "HOA"} Notes {`(${certNoteList?.length || 0})`}</p>
                    <i
                        title={'Add Note'} className="fa fa-plus-circle ml-auto cursor" aria-hidden="true"
                        onClick={(e) => {
                            setType(noteType);
                            e.preventDefault();
                            setShowAddNoteForm(true);
                        }} /></div>
                <div className="tax_list">
                    <ul className="border border-[#d0d2d5] bg-text-1 p-2">
                        {certNoteList && certNoteList.length === 0 &&
                            <li className="d-flex align-items-center">No Notes found</li>
                        }
                        {certNoteList && certNoteList.length > 0 && certNoteList.map((curAccount: any) => {
                            return (
                                <li className="flex items-center justify-between border-b border-surface-5 bg-text-1">
                                    <p>{curAccount.noteBody}</p>
                                    <i className="fa fa-trash ml-auto" aria-hidden="true" title={'Delete Note'}
                                        onClick={() => {
                                            setCertNoteId(curAccount.id);
                                            setShowDeleteNoteConfirmation(true);
                                        }}
                                    /></li>
                            )
                        })
                        }
                    </ul>
                </div>
            </div>

            <div className="bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]">
                <div
                    className={noteType === "TAX" ? "p-1 bg-highlight-5  m-0 text-text-1 flex items-center" : "p-1 bg-highlight-1 px-1 py-2  m-0 text-text-1 flex items-center"}>
                    <p className="mb-0">Similar
                        Accounts {similarAccountList && similarAccountList.length > 0 && '(' + similarAccountList.length + ')'}</p>
                    <i className={similarTaxAccountListResponse.isFetching ? "fa fa-refresh fa-spin ml-auto h-4 mr-1" : "fa fa-refresh ml-auto cursor-pointer mr-1"}
                        title={'Reload Account'} onClick={(e) => {
                            if (editable) {
                                e.preventDefault();
                                setReloadSimilarAccount(true);
                            }
                        }}
                    />
                </div>
                <div
                    className={similarAccountList && similarAccountList.length > 5 ? "tax_list table-responsive similar_table_height" : "tax_list table-responsive"}>
                    <table
                        className={noteType === "TAX" ? "table table_data tax-summary-table margin_bottom_custom" : "hoa_assessment table table_data hoa_border_none margin_bottom_custom"}>
                        <tbody>

                            {similarAccountList && similarAccountList.length === 0 &&
                                <tr>
                                    <td colSpan={3}>No accounts found</td>
                                </tr>
                            }

                            {similarAccountList && similarAccountList.length > 0 && similarAccountList.map((curAccount: any) => {
                                return (
                                    <tr>
                                        <td className="w-full"><a
                                            className={"text-highlight-4 hover:text-highlight-7 cursor"}
                                            href={noteType === "TAX" ? '/orders/taxCertEditor/' + curAccount.orderId : (productType === 'HOA_CONTACT' ? '/orders/hoaContactEditor/' + curAccount.orderId : '/orders/hoaFullEditor/' + curAccount.orderId)}
                                            target={"_blank"}>{curAccount.customerOrderNumber}</a></td>
                                        <td className="!text-end"><i className={`fa fa-clone ml-auto ${noteType === "TAX"  ? 'text-highlight-0' : 'text-highlight-1'}`}
                                            onClick={(e) => {
                                                if (editable) {
                                                    e.preventDefault();
                                                    setCustomerOrderNumber(curAccount.customerOrderNumber);
                                                    setShowAccountCloneModal(true);
                                                }
                                            }} title={'Clone Account'} aria-hidden="true" /></td>
                                    </tr>
                                )
                            })
                            }

                        </tbody>
                    </table>
                </div>
            </div>

            {/*************************************************Vendor Tasks List Starts*****************************************/}


            <div className="bg-text-1 rounded-lg shadow-md mt-3">
                <div
                    className={noteType === "TAX" ? "p-1 bg-highlight-5 d-flex align-items-center m-0 text-text-1 d-flex align-items-center d-flex align-items-center" : " bg-highlight-1 px-1 py-2 d-flex align-items-center m-0 text-text-1 d-flex align-items-center d-flex align-items-center"}>
                    <p className="mb-0">Order Tasks</p>

                </div>

                <div className="tax_list table-responsive">

                    <table
                        className={`${noteType === "TAX" ? "table table_data tax-summary-table margin_bottom_custom" : "hoa_assessment table table_data hoa_border_none margin_bottom_custom"}table-fixed w-full`}>

                        <tbody>
                            {vendorTaskList && vendorTaskList.length === 0 &&
                                <tr>
                                    <td colSpan={3}>No tasks found</td>
                                </tr>
                            }
                            {
                                vendorTaskList && vendorTaskList.length > 0 && vendorTaskList.map((curTask: any) => {
                                    return (
                                        <tr className="border-t border-surface-5">

                                            <td style={{ position: "relative" }}>
                                                <span>{curTask.type === 'SCRAPER' ? 'Tax Update' : curTask.type === 'BONDS' ? "Bonds" : curTask.type === 'AVANTA' ? "Avanta" : ""}</span>
                                            </td>
                                            <td>
                                                {(curTask.status === 'PENDING') &&
                                                    <>
                                                        <span
                                                            className={"text-highlight-4  text-xs font-semibold"}> {curTask.status}</span>
                                                    </>}
                                                {(curTask.status === 'ISSUE') &&
                                                    <>
                                                        <span
                                                            title={curTask.args != null ? curTask.args.message !== undefined ? curTask.args.message : "" : ""}
                                                            className={"badge badge-danger-data "}> {curTask.status}</span>
                                                    </>}
                                                {(curTask.status === 'COMPLETE') &&
                                                    <>
                                                        <span
                                                            className={"text-[#2CA949]  text-xs font-semibold"}> {curTask.status}</span>
                                                    </>}
                                                {(curTask.status === 'NEW' || curTask.status === 'CANCELED') &&
                                                    <>
                                                        <span
                                                            className={"text-[#6c757d] text-xs font-semibold"}> {curTask.status}</span>
                                                    </>}
                                            </td>
                                            {curTask.status === "ISSUE" && curTask.type === "AVANTA" &&
                                                <td title={curTask?.status === "ISSUE" && curTask?.type === "AVANTA" ? "Edit Order" : undefined}>
                                                    <i className="fa fa-edit" style={{ color: "green" }} onClick={(e) => {
                                                        if (editable) {
                                                            e.preventDefault();
                                                            setPropertyId(curTask.args !== null ? curTask.args.propertyId : null);
                                                            setTaskId(curTask.id);
                                                            setPropertyResultData(curTask.args !== null ? curTask.args.property !== null ? curTask.args.property.propertyResult : null : null);
                                                            setShowVendorPropertyResolver(true);
                                                        }
                                                    }}
                                                    />
                                                </td>
                                            }
                                            {curTask.status === 'CANCELED' && curTask.type === "BONDS" &&
                                                <td className={"text-right"} title={"Refresh Order"}>
                                                    <i className="fa fa fa-undo" style={{ color: "#4682b4" }}
                                                        onClick={(e) => {
                                                            if (editable) {
                                                                e.preventDefault();
                                                                setTaskHandleType("REFRESH");
                                                                setTaskId(curTask.id);
                                                                setCancelOrderModel(true);
                                                            }
                                                        }} />
                                                </td>}


                                            {(curTask.status === 'NEW' || curTask.status === 'PENDING' || curTask.status === 'ISSUE') &&
                                                <td className={"text-right"} title={"Cancel Order"}>
                                                    <i className="fa fa-window-close" style={{ color: "red" }}
                                                        onClick={(e) => {
                                                            if (editable) {
                                                                e.preventDefault();
                                                                setTaskHandleType("CANCEL");
                                                                setTaskId(curTask.id);
                                                                setCancelOrderModel(true);
                                                            }
                                                        }} />
                                                </td>}
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
            </div>

            {/*************************************************Vendor Tasks List Ends*****************************************/}

            <div className="bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)] mt-3">
                <div className={`p-1 m-0 text-text-1 flex items-center ${noteType === "TAX" ? "bg-highlight-5" : "bg-highlight-1"}  ${(noteType === "HOA" && unAcknowledged?.length > 0) ? "bg-highlight-1" : ""}
                 ${(unAcknowledged?.length > 0) ? "border-b-[8px] border-b-error-1 px-1 py-2" : ""} `}>
                    <p className="mb-0">QC Results
                        ({unAcknowledged && unAcknowledged.length}/{qcResultList && qcResultList.length})</p>


                    <i className={isRefetching ? "fas fa-sync fa-spin ml-auto" : (showAllQcResult ? "fa fa-2x fa-toggle-on ml-auto cursor" : "fa fa-2x fa-toggle-off ml-auto cursor")}
                        title={!isRefetching ? (showAllQcResult ? "Show Un-Acknowledged Results" : "Show all result") : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            setShowAllQcResult(!showAllQcResult);
                        }}
                    />

                </div>

                {qcResultList && showAllQcResult &&
                    getQcLogicResultList(qcResultList, noteType, setQcId, assignTo)
                }
                {unAcknowledged && !showAllQcResult &&
                    getQcLogicResultList(unAcknowledged, noteType, setQcId, assignTo)
                }

                {showDeleteAccountConfirmation &&
                    <ConfirmationModal
                        title={"Delete Account"}
                        bodyMessage={"Are you sure you want to delete this account?"}
                        onSubmit={deleteAccount}
                        show={showDeleteAccountConfirmation}
                        setShow={setShowDeleteAccountConfirmation}
                        isLoading={disable}
                        isHoa={noteType !== "TAX"}
                    />
                }




                {showAddNoteForm &&
                    <NoteAddSection show={showAddNoteForm} setShow={setShowAddNoteForm} title={"Add Note"}
                        orderId={orderId} noteType={type} types={["CUSTOMER", noteType]}
                        isHoaEditor={noteType !== "TAX"}
                    />
                }
                {showDeleteNoteConfirmation &&
                    <ConfirmationModal title={"Delete Note"}
                        bodyMessage={"Are you sure you want to delete this Note?"}
                        onSubmit={deleteCertNote} show={showDeleteNoteConfirmation}
                        setShow={setShowDeleteNoteConfirmation}
                        isLoading={deleteApi.isLoading}
                        isHoa={noteType !== "TAX"}

                    />
                }
                {
                    cancelOrderModel &&
                    <ConfirmationModal title={taskHandleType === 'REFRESH' ? "Refresh Order Task" : "Cancel Order Task"}
                        bodyMessage={taskHandleType === 'REFRESH' ? "Are you sure you want to restart this task?" : "Are you sure you want to cancel this task?"}
                        onSubmit={cancelOrder}
                        show={cancelOrderModel}
                        setShow={setCancelOrderModel}
                        isHoa={noteType !== "TAX"}
                        isLoading={cancelOrderOnVendorResponse.isLoading}
                    />
                }
                {
                    showPropertyPickerModal &&
                    <EditorPropertyPickerModal show={showPropertyPickerModal} setShow={setShowPropertyPickerModal}
                        isAddAccountPropertyRef={isAddAccountPropertyRef}
                        setAddedNewAccount={setAddedNewAccount}
                        setIsAddAccountPropertyRef={setIsAddAccountPropertyRef}
                        setAddAccountSelectedProperty={setAddAccountSelectedProperty}
                        orderData={JSON.parse(JSON.stringify(orderData))}
                        taxAccountNumber={taxAccountNumber}
                        propertyIds={JSON.parse(JSON.stringify(certificate.propertyIds.map((cur: any) => {
                            return cur.id
                        })))}
                        setTaxAccountNumber={setTaxAccountNumber} address={address}
                        setAddress={setAddress}
                        legalDescription={legalDescription}
                        setLegalDescription={setLegalDescription}
                        ownerName={ownerName}
                        setOwnerName={setOwnerName}
                        isHoaEditor={noteType !== "TAX"}
                        getPropertyPickerResultApi={getPropertyPickerResultApi}
                        getPropertyPickerResult={getPropertyPickerResult}
                        

                    />
                }
                {showAccountCloneModal &&
                    <CloneAccountsModal setShow={setShowAccountCloneModal} show={showAccountCloneModal}
                        tenant={orderData.data?.tenant} orderId={orderId}
                        countyData={countyResp}
                        existingProperty={certificate.accounts}
                        setSelectedCloneAccountList={setSelectedCloneAccountList}
                        customerOrderNumber={customerOrderNumber}
                        setCustomerOrderNumber={setCustomerOrderNumber}
                        isHoaEditor={noteType !== "TAX"}
                        state={orderData.data?.state}
                    />
                }
            </div>
        </>
    )
}
export default LeftBar

function getQcLogicResultList(list: any, noteType: any, setQcId: any, assignTo: any) {
    return (
        <div
            className={"tax_list table-responsive max-h-[220px] overflow-y-scroll [&::-webkit-scrollbar]:hidden "}>
            <table
                className={noteType === "TAX" ? "table table_data tax-summary-table margin_bottom_custom" : "hoa_assessment table table_data hoa_border_none margin_bottom_custom"}>
                <tbody className={"text-xs"}>
                    {list && list.length === 0 &&
                        <tr>
                            <td colSpan={3}>No results found</td>
                        </tr>
                    }
                    {list && list.length > 0 && list.map((curLogic: any) => {
                        return (
                            <tr className="border-t border-surface-5">
                                <td title={curLogic.acknowledgedBy !== null && curLogic.acknowledgedBy !== '' ? 'Acknowledged by: ' + curLogic.acknowledgedBy : ''}>
                                    {/* TRUE means that the rule triggered, and we show the RED symbol. FALSE means that the rule didn't trigger, and we show the GREEN symbol.*/}

                                    <i className={!curLogic.result ? "fa fa-check-circle text-[#28a745]" : (curLogic.acknowledgedBy === null && assignTo != null && assignTo !== "" ? `fa fa-times-circle text-error-1 error_cl cursor ` : `fa fa-times-circle text-error-1  error_cl opacity-50 pointer-events-none`)}
                                        aria-hidden="true"
                                        onClick={() => {
                                            if (curLogic.result === true && (curLogic.acknowledgedBy === null || curLogic.acknowledgedBy === "")) {
                                                setQcId(curLogic.id);
                                            }
                                        }} />
                                </td>
                                <td title={curLogic.qcLogic.description}>{curLogic.qcLogic.name}</td>
                                <td>{curLogic.message}</td>
                            </tr>
                        )
                    })
                    }
                </tbody>
            </table>
        </div>
    )
}